import React from 'react';
import { MapPin, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-100 pt-16 pb-8" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-34">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-35">
            <img src="https://cdn.magicpatterns.com/uploads/nRTWyz1hEwVbTBgmEWT7Fq/Untitled_design_(2)-Photoroom.png" alt="Justice Moving Co. Logo" className="h-20 w-auto object-contain mb-4 -ml-2" data-id="element-36" />
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-37">
              Reliable, professional moving services dedicated to making your
              transition smooth and stress-free.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-38">
            <h4 className="font-bold text-navy mb-4" data-id="element-39">Quick Links</h4>
            <ul className="space-y-2" data-id="element-40">
              <li data-id="element-41">
                <a href="#" className="text-gray-500 hover:text-gold transition-colors text-sm" data-id="element-42">
                  Home
                </a>
              </li>
              <li data-id="element-43">
                <a href="#services" className="text-gray-500 hover:text-gold transition-colors text-sm" data-id="element-44">
                  Services
                </a>
              </li>
              <li data-id="element-45">
                <a href="#quote" className="text-gray-500 hover:text-gold transition-colors text-sm" data-id="element-46">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div data-id="element-47">
            <h4 className="font-bold text-navy mb-4" data-id="element-48">Service Areas</h4>
            <ul className="space-y-2" data-id="element-49">
              <li className="text-gray-500 text-sm flex items-center" data-id="element-50">
                <MapPin className="h-4 w-4 mr-2 text-gold" data-id="element-51" /> Salt Lake County
              </li>
              <li className="text-gray-500 text-sm flex items-center" data-id="element-52">
                <MapPin className="h-4 w-4 mr-2 text-gold" data-id="element-53" /> Utah County
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-54">
            <h4 className="font-bold text-navy mb-4" data-id="element-55">Contact Us</h4>
            <ul className="space-y-3" data-id="element-56">
              <li data-id="element-57">
                <a href="mailto:team@justicemovingco.com" className="text-gray-500 hover:text-gold transition-colors text-sm flex items-center" data-id="element-58">
                  <Mail className="h-4 w-4 mr-2 text-gold" data-id="element-59" />{' '}
                  team@justicemovingco.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-60">
          <p className="text-gray-400 text-sm text-center md:text-left mb-4 md:mb-0" data-id="element-61">
            &copy; {new Date().getFullYear()} Justice Moving Co. All rights
            reserved.
          </p>
          <div className="flex space-x-4" data-id="element-62">
            <a href="#" className="text-gray-400 hover:text-navy text-sm transition-colors" data-id="element-63">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-navy text-sm transition-colors" data-id="element-64">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}